import {
  EuiSkeletonText,
  EuiModal,
  EuiModalBody,
  EuiModalHeader,
  EuiModalHeaderTitle,
  EuiModalProps,
} from "@inscopix/ideas-eui";

interface ModalErrorProps {
  title?: string;
  onClose: EuiModalProps["onClose"];
}

/**
 * Displays an loading modal
 */
export const ModalLoading = ({ title, onClose }: ModalErrorProps) => {
  return (
    <EuiModal onClose={onClose}>
      <EuiModalHeader>
        <EuiModalHeaderTitle>{title ?? "Loading"}</EuiModalHeaderTitle>
      </EuiModalHeader>

      <EuiModalBody>
        <EuiSkeletonText lines={5} />
      </EuiModalBody>
    </EuiModal>
  );
};
